// 2026-05-15 — Barre Live/Connects/Booked/Pending/RDVs desactivee.
// Doublonne avec la ListCallStatsBar (Connecte/RDV/Pas de reponse/Nouveau)
// qui est plus pertinente pour l'agent. Composant conserve sous forme de
// stub au cas ou on voudrait le re-activer plus tard.

export default function OnCallStatusBar() {
  return null;
}
